import React from 'react';
import {
    Box,
    Typography,
    Button,
    Avatar,
    Stack,
    Paper,
} from '@mui/material';
import {
    LocalHospital,
    LocalPharmacy,
    Science,
    LocalHotel,
    LocalShipping,
    AccountBalanceWallet,
    Groups,
    CheckBox,
} from '@mui/icons-material';

import doctors from "../../Assets/images/doctors.png";
import { useNavigate } from 'react-router-dom';



export default function LandingPageWidget({patientCount}) {

    const navigate = useNavigate();
     const role = sessionStorage?.getItem("role");
    
      const isDoctor = role === "Doctor";

    const services = [
        { label: 'Doctor', icon: <LocalHospital />, onClick: () => navigate('/doctors') },
        { label: 'Pharmacy', icon: <LocalPharmacy /> , onClick: () => navigate('/pharmacy-page')},
        { label: 'Lab', icon: <Science />,  onClick: () => navigate('/labs-page')  },
        { label: 'Hospitals', icon: <LocalHotel /> ,  onClick: () => navigate('/hospitals')  },
        // { label: 'Ambulance', icon: <LocalShipping /> },
        { label: 'Wallet', icon: <AccountBalanceWallet />,  onClick: () => navigate('/billing') },
        { label: 'Socials', icon: <Groups />,  onClick: () => navigate('/socials')  },
        // { label: 'Others', icon: <CheckBox /> },
    ];

    return (
        <Box p={2}>
            {/* Top Flex Cards */}
            <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2} mb={3}>
                {/* First Card - Only show for doctors */}
                {isDoctor && (
                    <Paper
                        sx={{
                            backgroundColor: 'green',
                            color: 'white',
                            flex: 1,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            p: 1.5,
                            borderRadius: 2,
                            position: "relative",
                            minHeight: 140
                        }}
                    >
                        <Box sx={{ flexBasis: "50%", zIndex: 1 }}>
                            <Typography variant="subtitle2" fontWeight="bold">
                                Manage patient interaction
                            </Typography>
                            <Typography variant="caption" display="block" mb={1}>
                                In-Clinic and Off-site
                            </Typography>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => navigate('/patients')}
                                sx={{ backgroundColor: 'white', color: 'black', textTransform: 'none' }}
                            >
                                See Patients
                            </Button>
                        </Box>
                        <Box
                            component="img"
                            src={doctors}
                            alt="doctor"
                            sx={{
                                height: 160,
                                width:120,
                                position: "absolute",
                                right: "-10px",
                                top: "-40px",
                                zIndex: 0,
                            }}
                        />
                    </Paper>
                )}

                {/* Second Card */}
                <Paper
                    sx={{
                        backgroundColor: '#5D3A00',
                        color: 'white',
                        flex: 1,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 1.5,
                        borderRadius: 2,
                        position: "relative",
                        minHeight: 140
                    }}
                >
                    <Box sx={{ display: "flex", flexBasis: "50%", flexDirection: "column", zIndex: 1 }}>
                        <Typography variant="subtitle2" fontWeight="bold">
                            Community
                        </Typography>
                        <Typography variant="caption" display="block" mb={1}>
                            Join {patientCount} users on this platform
                        </Typography>
                        <Button
                            variant="contained"
                            size="small"
                            sx={{
                                backgroundColor: 'white',
                                color: 'black',
                                textTransform: 'none'
                            }}
                            onClick={() => navigate('/groups-page')}
                        >
                            Join a community
                        </Button>
                    </Box>
                    <Box
                        component="img"
                        src={doctors}
                        alt="doctor"
                        sx={{
                            height: 160,
                            width:120,
                            position: "absolute",
                            right: "-10px",
                            top: "-40px",
                            zIndex: 0,
                        }}
                    />
                </Paper>

                {/* Services Box */}
                <Box
                    border="1px solid green"
                    borderRadius={2}
                    p={2}
                    display="flex"
                    flexWrap="wrap"
                    justifyContent="space-evenly"
                    alignItems="center"
                    backgroundColor="white"
                >
                    {services.map((service, index) => (
                        <Stack
                            key={index}
                            alignItems="center"
                            spacing={0.5}
                            sx={{ minWidth: 60, mb: 2, cursor:"pointer" }}
                            onClick={service.onClick}
                            
                        >
                            <Avatar
                                sx={{
                                    bgcolor: '#EAFFEB',
                                    border: '1px solid green',
                                    color: 'green',
                                    width: 48,
                                    height: 48,
                                }}
                            >
                                {service.icon}
                            </Avatar>
                            <Typography variant="caption" fontSize={11}>
                                {service.label}
                            </Typography>
                        </Stack>
                    ))}
                </Box>
            </Box>

        </Box>
    );
}
